import React from "react";

export interface ImportJob {
  id: string;
  stage: "reading" | "generating" | "validating" | "repairing" | "saving" | "succeeded" | "failed";
  message: string;
  totalSources: number;
  completedSources: number;
  blocks: number;
  images: number;
  attempt: number;
  maxAttempts: number;
  startedAt: string;
  updatedAt: string;
  articleId?: string;
  retryable: boolean;
  events: Array<{ at: string; message: string }>;
}

export function ImportProgress({ job, disabled, onRetry, onOpen }: { job: ImportJob; disabled: boolean; onRetry: () => void; onOpen: () => void }) {
  const done = job.stage === "succeeded";
  const failed = job.stage === "failed";
  const index = ({ reading: 0, generating: 1, validating: 2, repairing: 2, saving: 3, succeeded: 4, failed: job.attempt ? 2 : 0 })[job.stage];
  const seconds = Math.max(0, Math.floor(((done || failed ? Date.parse(job.updatedAt) : Date.now()) - Date.parse(job.startedAt)) / 1000));
  return <section className={`card import-progress ${failed ? "import-failed" : ""}`}>
    <div className="card-header"><h2>文章导入进度</h2><span className="hint">已用时 {seconds < 60 ? `${seconds} 秒` : `${Math.floor(seconds / 60)} 分 ${seconds % 60} 秒`}</span></div>
    <div className="import-progress-body"><div className="import-steps">{["读取文档", "AI 生成", "校验纠错", "保存文章"].map((name, step) => <div key={name} className={`import-step ${step < index ? "complete" : ""} ${step === index ? "current" : ""}`}><span>{step < index ? "✓" : step + 1}</span>{name}</div>)}</div>
      <p className={`import-message ${failed ? "error-text" : ""}`} role="status">{!done && !failed && <span className="spinner"/>}{job.message}</p>
      <div className="import-metrics"><span>文档 <strong>{job.completedSources}/{job.totalSources}</strong></span><span>已读 <strong>{job.blocks}</strong> 段</span><span>图片 <strong>{job.images}</strong> 张</span><span>AI 尝试 <strong>{job.attempt}/{job.maxAttempts}</strong></span></div>
      {job.stage === "repairing" && <p className="hint">正在把错误交回 AI 修复, 已读取的文档和素材会保留</p>}
      <ol className="import-events">{job.events.slice(-8).map((event, eventIndex) => <li key={`${event.at}-${eventIndex}`}><time>{new Date(event.at).toLocaleTimeString()}</time><span>{event.message}</span></li>)}</ol>
      {(done || failed && job.retryable) && <div className="row-actions">{done && <button className="btn btn-primary" disabled={disabled} onClick={onOpen}>查看生成文章</button>}{failed && job.retryable && <button className="btn btn-primary" disabled={disabled} onClick={onRetry}>继续重试, 复用已读资料</button>}</div>}
    </div>
  </section>;
}
